import React from 'react';
import styles from './css/index.module.scss';

function Pricacy() {
  return (
    <div className={styles.aboutWrapper}>
      <div id="dev_page_content_wrap" className=" ">
        <div className="dev_page_bread_crumbs" />
        <h1 id="dev_page_title">Privacy</h1>

        <div id="dev_page_content">
          <h2>
            <a className="anchor-link" href="#1-introduction">
              <i
                className="anchor-icon"
              />
            </a>
            <a className="anchor" name="1-introduction" />
            1. Introduction
          </h2>
          <p>
            This Privacy Policy is meant to help you clearly identify which personal data we collect when you use
            Fragment (the “Exchange”), why we process it and how we are securing it. For the purposes of this
            document, ‘we’, ‘us’ and ‘our’ refers to Fragment Corp. (the “Company”), ‘Telegram’ refers to Telegram
            Messenger Inc., and ‘you’ refers to you, the user.
          </p>
          <p>
            By using or browsing Exchange or any service provided by Company you acknowledge that you have read,
            understood and agreed to this policy.
          </p>
          <h2>
            <a className="anchor-link" href="#1-1-principles"><i className="anchor-icon" /></a>
            <a
              className="anchor"
              name="1-1-principles"
            />
            1.1 Principles
          </h2>
          <p>
            Privacy is the core principle that rules the development of all current and future services owned and
            offered by Company.
          </p>
          <p>
            Exchange is a privacy-focused, non-custodial trading and auctioning platform based on the fully
            decentralized TON blockchain technology. Company commits to not collecting, generating or processing any
            personal or otherwise identifiable user data that is not strictly necessary to provide these
            services.
            {' '}
          </p>
          <h2>
            <a className="anchor-link" href="#2-what-personal-data-we-use"><i className="anchor-icon" /></a>
            <a
              className="anchor"
              name="2-what-personal-data-we-use"
            />
            2. What Personal Data We Use
          </h2>
          <h4>
            <a className="anchor-link" href="#2-1-account-data"><i className="anchor-icon" /></a>
            <a
              className="anchor"
              name="2-1-account-data"
            />
            2.1 Account Data
          </h4>
          <p>
            Exchange doesn't offer a dedicated registration method; you may log in via Telegram and/or via your TON
            wallet. Your usage of these third-party services may be further subject to the third party's terms.
            Company
            <strong>does not</strong>
            {' '}
            store any data that links these two login methods to your IP address,
            browser agent, hardware, other identifiable information or to each other.
          </p>
          <h4>
            <a className="anchor-link" href="#2-2-transaction-and-purchase-history-data">
              <i
                className="anchor-icon"
              />
            </a>
            <a
              className="anchor"
              name="2-2-transaction-and-purchase-history-data"
            />
            2.2 Transaction
            and Purchase History Data
          </h4>
          <p>
            Exchange stores its full transaction history on the
            <strong>public</strong>
            {' '}
            immutable TON ledger and
            references it to determine the ownership of any entity available for sale or auction.
          </p>
          <h4>
            <a className="anchor-link" href="#2-3-activity-history"><i className="anchor-icon" /></a>
            <a
              className="anchor"
              name="2-3-activity-history"
            />
            2.3 Activity History
          </h4>
          <p>
            Company
            <strong>does not</strong>
            {' '}
            store your search history on Exchange. Company may store some user
            preferences, such as your notification settings on individual auctions.
          </p>
          <h4>
            <a className="anchor-link" href="#2-4-anonymous-statistics"><i className="anchor-icon" /></a>
            <a
              className="anchor"
              name="2-4-anonymous-statistics"
            />
            2.4 Anonymous Statistics
          </h4>
          <p>
            Company may at times collect or process anonymized information about your device, IP address or browser
            agent to prevent abuse and to improve how Exchange provides its services. This information is not tied and
            cannot be traced back to your Telegram account, TON Wallet, activity history or any other operation on
            Exchange. Company will store this data for no longer than 6 months.
          </p>
          <h4>
            <a className="anchor-link" href="#2-5-usage-of-purchased-entities"><i className="anchor-icon" /></a>
            <a
              className="anchor"
              name="2-5-usage-of-purchased-entities"
            />
            2.5 Usage of Purchased Entities
          </h4>
          <p>
            Exchange may provide integrations with other platforms to facilitate the usage of collectibles on
            third-party services. After you terminate a login session originated from any such integration, all data
            related to it is erased and Company has no way of tracking how or if you continue to use your entities, on
            what platforms and for what purposes.
            {' '}
          </p>
          <p>
            No data regarding how you employ your entities is ever stored by Company and their usage is governed
            solely by the Privacy Policies and Terms of Service of the platforms where you intend to employ them, as
            agreed between you and the relevant third parties.
          </p>
          <h2>
            <a className="anchor-link" href="#3-how-we-use-your-data"><i className="anchor-icon" /></a>
            <a
              className="anchor"
              name="3-how-we-use-your-data"
            />
            3. How We Use Your Data
          </h2>
          <p>
            Exchange doesn't store funds and doesn't link transactions to login metadata. For this reason, the only
            private data it processes relates to your notification settings on individual auctions, should you choose
            to enable them. Company does not store your notification setting history, so the information is lost the
            moment you disable them.
          </p>
          <p>
            Anonymized access or user agent data as outlined in
            <strong>2.4</strong>
            {' '}
            is used to prevent abuse and
            facilitate rate-limiting functionalities on Exchange, to improve the services it offers and to comply with
            applicable local and regional law.
          </p>
          <h2>
            <a className="anchor-link" href="#4-who-your-personal-data-may-be-shared-with">
              <i
                className="anchor-icon"
              />
            </a>
            <a
              className="anchor"
              name="4-who-your-personal-data-may-be-shared-with"
            />
            4. Who Your
            Personal Data May Be Shared With
          </h2>
          <p>
            Company stores no transaction data, identifiable logs or activity history. For this reason, it is
            impossible to share this data with any third party. All auctions, sales and entities are publicly
            available on the TON blockchain.
          </p>
          <p>
            To comply with law enforcement requests and legal process, such as a court order or subpoena, Company may
            disclose its usage statistics. This metadata cannot be traced back to any purchase, bid, Telegram account
            or TON Wallet.
          </p>
          <h2>
            <a className="anchor-link" href="#5-your-rights"><i className="anchor-icon" /></a>
            <a
              className="anchor"
              name="5-your-rights"
            />
            5. Your Rights
          </h2>
          <p>
            Since we do not store any personal information, you do not need to request its deletion or worry about
            its safety. If you wish to opt out of this privacy policy, you may stop using our services at any
            time.
          </p>
          <h2>
            <a className="anchor-link" href="#6-third-party-services"><i className="anchor-icon" /></a>
            <a
              className="anchor"
              name="6-third-party-services"
            />
            6. Third-Party Services
          </h2>
          <p>
            Exchange may contain links to third-party services or platforms, namely Telegram and various TON wallets.
            <br />
            This
            Policy does not govern your usage of those services and by using them you agree to the respective
            individual Terms and Privacy Policies.
          </p>
          <h2>
            <a className="anchor-link" href="#7-changes-to-this-privacy-policy">
              <i
                className="anchor-icon"
              />
            </a>
            <a className="anchor" name="7-changes-to-this-privacy-policy" />
            7.
            Changes to this Privacy Policy
          </h2>
          <p>
            We reserve the right to revise and modify this policy at our sole discretion. While we do not anticipate
            frequent changes, you should check this page frequently to stay updated on the latest version.
            {' '}
          </p>
          <p>We will post a summary of any significant change under this section.</p>
        </div>

      </div>
    </div>
  );
}

export default Pricacy;
